var map = {
	"./general/brightness_chart.jpg": 7515,
	"./general/capsule-light-2.0_1.webp": 7204,
	"./general/capsule.jpg": 4082,
	"./general/extreme_glow.jpg": 3119,
	"./general/flowlight.jpg": 3279,
	"./general/glow_products.jpg": 2705,
	"./others/shoelaces.jpg": 2427,
	"./others/veil_fan.jpg": 5508,
	"./others/wand.jpg": 472,
	"./poi/crystal.jpg": 1845,
	"./poi/drexfactor.jpg": 1715,
	"./poi/fuzzy.jpg": 2975,
	"./poi/playpoi.jpg": 5217,
	"./poi/podpoi.jpg": 84,
	"./poi/podpoi_handles.jpg": 696,
	"./poi/timmehtek.jpg": 1343,
	"./staff/composite-iso-baton.png": 9481,
	"./staff/composite-stick.png": 203,
	"./staff/dragon-staff.png": 1085,
	"./staff/flowlights-staff.png": 4959,
	"./staff/mcs.png": 4926,
	"./whips/firecatflow.jpg": 2998,
	"./whips/flowgrease.jpg": 4629,
	"./whips/flowmi.jpg": 6026,
	"./whips/lightwhippingnotebook.jpg": 6807,
	"./whips/pixelwhiprev4.jpg": 7101,
	"./whips/rgbcritter.jpg": 2058,
	"./whips/spacewhipremix.jpg": 3379
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 74;